import { Children, cloneElement } from "react"
import { includes } from "lodash"
import { clsx } from "@/utilities"

const SelectionRow = ({ children, isDisabled, ...props }) => {
    return (
        <tr {...props}>
            {Children.map(children, (child, index) => {
                const component = child.props?.component
                if (typeof component === "function") {
                    const _component = (ownProps) =>
                        component({
                            ...ownProps,
                            rowKey: props["data-row-key"],
                            isRowDisabled: isDisabled
                        })

                    return cloneElement(child, {
                        ...child.props,
                        key: index,
                        component: _component
                    })
                }
                return child
            })}
        </tr>
    )
}

const SelectionCell = ({
    rowKey,
    rowSelection: { selectedRowKeys, onChange },
    isRowDisabled,
    ...props
}) => {
    const handleClick = (evt) => {
        evt.stopPropagation()
        if (!isRowDisabled) {
            const keys = new Set(selectedRowKeys)
            keys.has(rowKey) ? keys.delete(rowKey) : keys.add(rowKey)
            onChange(Array.from(keys))
        }
    }

    if (includes(props.className, "no-click-selection")) {
        return <td {...props} />
    }

    return <td {...props} onClick={handleClick} />
}

export function RowBuilder({ rowSelection, builder, ...props }) {
    if (typeof builder === "function") {
        return builder(props)
    }

    if (typeof rowSelection?.onChange === "function") {
        const record = props.children[0]?.props?.record
        const isDisabled = rowSelection.getCheckboxProps?.(record)?.disabled

        return (
            <SelectionRow
                {...props}
                isDisabled={isDisabled}
                className={clsx(props.className, isDisabled && "row-disabled")}
            />
        )
    }

    return <tr {...props} />
}

export function CellBuilder({ builder, rowSelection, ...props }) {
    if (typeof builder === "function") {
        return builder(props)
    }
    if (typeof rowSelection?.onChange === "function") {
        return <SelectionCell {...props} rowSelection={rowSelection} />
    }
    return <td {...props} />
}
